import React from "react";
import { openInteractivityModal } from "../../redux/modal/action";
import { connect } from "react-redux";
import {
  getPageNumber,
  getValue,
  sendAnalyticsEvent
} from "../../helper/utility";
import { setIndexCarousel } from "../../redux/carousel/action";
import { gaEventLabel } from "../../settings/gaConfig";
import { styles } from "./searchBar.styles";

const BASE_PATH = "https://view.interattivo.net/giodicart";

const SearchResults = (props) => {
  const current = () => {
    sendAnalyticsEvent(
      gaEventLabel.searched_product,
      String(props.element.item_id)
    );
    sendAnalyticsEvent(
      gaEventLabel.open_product,
      String(props.element.item_id)
    );
    props.setIndexCarousel(getValue(getPageNumber(props.element.skul)));

    setTimeout(() => {
      const element = document.getElementById(`div-${props.element.item_id}`);
      if (element) {
        element.classList.add("fadeIn_interact");
        setTimeout(() => {
          element.classList.remove("fadeIn_interact");
        }, 3000);
      }
    }, 100);
    props.setDisplaySearchResults("none");
  };

  const external = () => {
    const link = `${BASE_PATH}/${props.element.slug}/products/${props.element.skul}`;
    window.open(link);
  };
  return (
    <div
      style={styles.containerDescription(props.itemHeigth)}
      onClick={() => {
        props.element.isCurrent ? current() : external();
      }}
      className="searchResultStyle row"
    >
      <p style={styles.description(props.itemHeigth)}>
        {props.element.description}
      </p>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal
  };
};

export default connect(mapStateToProps, {
  openInteractivityModal,
  setIndexCarousel
})(SearchResults);
